import React from "react";
import { LegacyRestorationProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import WildflowersIcon from "@ecologi/assets/icons/ProjectInsights/wildflowers.svg";
import SeagrassIcon from "@ecologi/assets/icons/ProjectInsights/seagrass.svg";
import PeatlandsIcon from "@ecologi/assets/icons/ProjectInsights/peatlands.svg";

const PATH = "/images/app/forest/habitat_restoration/pictograms/";

export const habitatRestorationVisuals: Record<
  LegacyRestorationProjectType,
  ProjectVisualsType
> = {
  [LegacyRestorationProjectType.Wildflowers]: {
    icon: <WildflowersIcon />,
    pictogram: `${PATH}wildflowers.svg`,
  },
  [LegacyRestorationProjectType.Seagrass]: {
    icon: <SeagrassIcon />,
    pictogram: `${PATH}seagrass.svg`,
  },
  [LegacyRestorationProjectType.Peatlands]: {
    icon: <PeatlandsIcon />,
    pictogram: `${PATH}peatlands.svg`,
  },
  [LegacyRestorationProjectType.All]: {
    icon: <></>,
    pictogram: "",
  },
  [LegacyRestorationProjectType.None]: {
    icon: <></>,
    pictogram: "",
  },
};
